import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from './../../services/user.service';
import { EncrDecrService } from './../../services/encr-decr.service';
@Component({
  selector: 'app-s-user-list',
  templateUrl: './s-user-list.component.html',
  styleUrls: ['./s-user-list.component.css']
})
export class SUserListComponent implements OnInit {


  public data: any = [];
  error: string;
  public temp_var: Object = false;
  user_id: any = '';
  token: any = '';
  APIKEY: any = 'SOAV2@123';
  sendUserInfo: any = {};
  delete_cmp_id: any;
  user_status: any;
  c_user_id: any;
  status: any;

  constructor(private _user: UserService,
    private _router: Router,
    private EncrDecr: EncrDecrService, private _activatedroute: ActivatedRoute,
    private toastr: ToastrService) { }

  ngOnInit() {
    this._activatedroute.params.subscribe(params => {
      this.status = params['status'];
    });
    this.user_id = localStorage.getItem('id');
    this.token = localStorage.getItem('token');
    this.sendUserInfo = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      status: this.status,
    };
    // getting data in user list
    this._user.getUserList(this.sendUserInfo)
      .subscribe(
        res => {
          //   console.log(res);
          if (res.status == true) {
            this.data = res.data;
          } else {
            this.data = [];
          }
          this.temp_var = true;
        },
      );
  }
  onChangeEvent(ev) {
    const status = ev.target.value;
    this._router.navigateByUrl('/redirect').then(() => {
      this._router.navigateByUrl('/super-admin/user-list/' + status);
    });
  }
  // getUserList()
  // {
  //   this._user.getUserList(this.sendUserInfo)
  //   .subscribe(
  //     res => { 
  //       this.data=res;
  //       this.temp_var=true;
  //       console.log(this.data);
  //    },
  //   ); 
  // }


  set_active_id(cid, status) {
    this.c_user_id = cid;
    this.user_status = status;
  }

  active_customer() {
    const data = {
      c_user_id: this.c_user_id,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      status: this.user_status,
    }

    this._user.activeuser(data)
      .subscribe(
        res => {
          this.toastr.success(res.message, 'Success');
          var url = '/super-admin/user-list/active';
          if (this.user_status == 'active') {
            url = '/super-admin/user-list/inactive';
          } else {
            url = '/super-admin/user-list/active';
          }
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl(url);
          });
        },
        err => console.log(err)
      );
  }
  redirectedinto(id) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), id);
    this._router.navigate(["/super-admin/edit-user/" + encrypted]);
  }

}
